import React from 'react'

import PencilChecklistPersonImageSrc from '../../../images/pencil-checklist-person.png'
import Heading from './Heading'
import Paragraph from './Paragraph'

interface EmptyStateProps {
    title?: string
    message?: string
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message, ...props }) => {
    return (
        <div className="flex flex-col items-center justify-center p-12" {...props}>
            <img src={PencilChecklistPersonImageSrc} className="w-[100px]" />

            <Heading size="xs" className="mt-4 mb-2 text-gray-700">
                {title}
            </Heading>
            <Paragraph className="text-gray-600">{message}</Paragraph>
        </div>
    )
}

export default EmptyState
